import React from "react";
import { Link } from "react-router-dom";

function Universe() {
  return (
    <div className="container mt-5">
      <div className="row text-center">
        <h1>The Zerodha Universe</h1>
        <p>
          Extend your trading and investment experience even further with our
          partner platforms
        </p>

        <div className="col-4 p-3 mt-5">
          <img src="images/smallcaseLogo.png" />
          <p className="text-small text-muted mt-1">
            Thematic investment platform
          </p>
        </div>

        <div className="col-4 p-3 mt-5">
          <img
            src="images/streakLogo.png"
            style={{ width: "140px", height: "auto" }}
          />
          <p className="text-small text-muted mt-2">Algo & platform</p>
        </div>

        <div className="col-4 p-3 mt-5 p-4">
          <img
            src="images/sensibullLogo.svg"
            style={{ width: "170px", height: "auto" }}
          />
          <p className="text-small text-muted mt-3">
            Options trading platform
          </p>
        </div>

        <div className="col-4 p-3 mt-5">
          <img
            src="images/zerodhaFundhouse.png"
            style={{ width: "160px", height: "auto" }}
          />
          <p className="text-small text-muted mt-1">Asset management</p>
        </div>

        <div className="col-4 p-3 mt-5">
          <img src="images/goldenpiLogo.png" />
          <p className="text-small text-muted mt-2">
            Bonds trading platform
          </p>
        </div>

        <div className="col-4 p-3 mt-5">
          <img
            src="images/dittoLogo.png"
            style={{ width: "100px", height: "auto" }}
          />
          <p className="text-small text-muted mt-3">Insurance</p>
        </div>

        {/* ✅ Redirect to signup */}
        <Link to="/signup">
          <button
            className="p-2 btn btn-primary fs-5 mb-5"
            style={{ width: "20%", margin: "0 auto" }}
          >
            Signup now
          </button>
        </Link>
      </div>
    </div>
  );
}

export default Universe;
